import { useMemo, useState } from "react";
import AuthService from "src/services/AuthService";
import RiskApprovalModal from "./RiskApprovalModal";
import CancelApplicationModal from "./CancelApplicationModal";
import { Applicant } from "src/types/Applicant";
import { ReduxApplication } from "src/types/Application";

interface ManualReviewActionsProps {
  application: ReduxApplication;
  highRiskApplicants?: Applicant[];
  isHighRiskApplication?: boolean;
  onActionSuccess?: () => void;
}

const ManualReviewActions = ({
  application,
  highRiskApplicants = [],
  isHighRiskApplication = false,
  onActionSuccess,
}: ManualReviewActionsProps) => {
  const [showApprovalModal, setShowApprovalModal] = useState(false);
  const [showCancelModal, setShowCancelModal] = useState(false);

  const isAuthorizedUser = useMemo(() => {
    return AuthService.isAuthorizedForRiskScoreApproval();
  }, []);

  if (!isAuthorizedUser || !application?.applicationId) {
    return null;
  }

  const handleApprovalConfirm = (wasSuccessful: boolean) => {
    setShowApprovalModal(false);
    if (wasSuccessful) {
      onActionSuccess?.();
    }
  };

  return (
    <>
      <div className="pause-actions">
        <span
          className="pause-action-text"
          role="button"
          tabIndex={0}
          onClick={() => setShowApprovalModal(true)}
        >
          Unpause Application
        </span>

        <span
          className="pause-action-text"
          role="button"
          tabIndex={0}
          onClick={() => setShowCancelModal(true)}
        >
          Cancel Application
        </span>
      </div>

      <RiskApprovalModal
        showModal={showApprovalModal}
        applicationId={application.applicationId}
        highRiskApplicants={highRiskApplicants}
        onConfirmApprove={handleApprovalConfirm}
        onCancel={() => setShowApprovalModal(false)}
      />

      <CancelApplicationModal
        selectedApplicant={
          application &&
          application.applicants.find((x) => x.applicantTypeId == 1)
        }
        selectedApplication={application}
        isHighRiskApplication={isHighRiskApplication}
        onCancel={() => setShowCancelModal(false)}
        show={showCancelModal}
      />
    </>
  );
};

export default ManualReviewActions;
